import React, { useEffect, useCallback, useState } from "react";
// import { reportingThunk } from "../../../store/actions/reportingmanagement/reporting.thunk";
import { employeeMngtThunk } from "../../../store/actions/employeemanagement/employee.thunk";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
import { PageBody } from "../../../components/loader";
import { useLoadingMessage } from "../../../components/useLoadingMessage";
import ReactHTMLTableToExcel from "react-html-table-to-excel";

export const ReportEmployee = () => {
  const { employees } = useSelector((state) => state.employeeMngt);
  const dispatch = useDispatch();
  const [searchEmployee, setSearchEmployee] = useState("");
  const { isLoading, message, updateLoader } = useLoadingMessage();

  console.log("report", employees);

  const getAllEmployees = useCallback(async () => {
    await dispatch(employeeMngtThunk.getEmployeesDetails());
    updateLoader(false);
  }, [dispatch]);

  useEffect(() => {
    getAllEmployees();
  }, []);

  const AllEmployee = employees.filter((employee) => {
    return (
      (employee &&
        employee.first_name
          .toLowerCase()
          .indexOf(searchEmployee.toLowerCase()) !== -1) ||
      (employee.roles &&
        employee.roles.name
          .toLowerCase()
          .indexOf(searchEmployee.toLowerCase()) !== -1) ||
      (employee.job_title &&
        employee.job_title.name
          .toLowerCase()
          .indexOf(searchEmployee.toLowerCase()) !== -1)
    );
  });
  return (
    <React.Fragment>
      <PageBody isLoading={isLoading} message={message}>
        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box-two">
                  <h4 className="page-title"></h4>
                  <h1 className="welcome_text">REPORT MANAGEMENT</h1>
                  <div className="clearfix"></div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className=" table-responsive">
                  <div className="table-title">
                    <div className="row">
                      <div className="col-sm-6">
                        <h2>
                          <b> EMPLOYEE SUMMARY </b>{" "}
                        </h2>
                      </div>
                      <div class="col-sm-6">
                        <Link to="/dashboard/report" className="btn  p-3">
                          <span class="fa fa-arrow-left"></span>&nbsp;Back&nbsp;
                        </Link>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-12 col-md-12 col-xs-12">
                      <div className="">
                        <div className="mb-3 clearfix">
                          <div
                            class="btn-group float-left"
                            role="group"
                            aria-label="Basic example"
                          >
                            <button
                              type="button"
                              class="btn btn-secondary btn-group-sm"
                              onClick={() => window.print()}
                            >
                              Print
                            </button>
                            <ReactHTMLTableToExcel
                              id="test-table-xls-button"
                              className="btn btn-secondary btn-group-sm"
                              table="report-employee"
                              filename="EMPLOYEE SUMMARY"
                              sheet="tablexls"
                              buttonText="Export to excel"
                            />
                          </div>

                          <form class="form-inline my-2 my-lg-0 float-right">
                            <input
                              class="form-control mr-sm-2"
                              type="search"
                              placeholder="Search"
                              aria-label="Search"
                              name="search"
                              value={searchEmployee}
                              onChange={(e) =>
                                setSearchEmployee(e.target.value)
                              }
                            />
                          </form>
                        </div>
                      </div>
                      <div className="" id="printTable">
                        <table
                          className="table table-striped table-hover learn-table"
                          id="report-employee"
                        >
                          {AllEmployee < 1 ? (
                            <div className="text-center m-auto">
                              <h1 className="text-dark">No record found</h1>
                            </div>
                          ) : (
                            <thead>
                              <tr>
                                <th>
                                  <b> S/N</b>
                                </th>
                                <th>
                                  <b>NAME</b>
                                </th>
                                <th>
                                  <b> STAFF ID </b>
                                </th>
                                <th>
                                  <b> JOB TITLE </b>
                                </th>
                                <th>
                                  <b> ROLE </b>
                                </th>
                                <th>
                                  <b> GENDER </b>
                                </th>
                                <th>
                                  <b> EMAIL </b>
                                </th>
                                <th>
                                  <b> STATUS </b>
                                </th>
                                <th>
                                  <b> DATE OF EMPLOYMENT </b>
                                </th>
                              </tr>
                            </thead>
                          )}
                          <tbody>
                            {AllEmployee.map((employee, i) => (
                              <tr key={i}>
                                <td>{i + 1}</td>
                                <td>{employee.first_name}</td>
                                <td>{employee.employee_number}</td>
                                <td>
                                  {employee.job_title &&
                                    employee.job_title.name}
                                </td>
                                <td>{employee.roles && employee.roles.name}</td>
                                <td>{employee.gender}</td>
                                <td>{employee.email}</td>
                                <td>
                                  {employee.is_active == 1
                                    ? "Active"
                                    : "Inactive"}
                                </td>
                                <td>
                                  {moment(employee.date_of_employment).format(
                                    "ll"
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </PageBody>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/container/dashboard/reportmanagement/employee_list.js